const POPOVER_MESSAGE = 'Unfortunately, it is not possible to place a bet directly '
    + 'via this page at present. Don\'t worry, this functionality will be available '
    + 'shortly. In the meantime, please use the Racecard page to place your bet.';

export default class BetInterceptor {
    constructor() {
        this.popoverEl = null;
        this.handleClick = this.handleClick.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.bindEvents();
    }

    bindEvents() {
        document.addEventListener('click', this.handleClick, true);
    }

    destroy() {
        document.removeEventListener('click', this.handleClick, true);
        document.removeEventListener('click', this.handleOutsideClick, false);
        this.removePopover();
    }

    handleClick(event) {
        const priceBtn = event.target.closest('.js-betHandler');
        if (!priceBtn) {
            return;
        }

        event.stopPropagation();
        event.preventDefault();
        this.showPopover(priceBtn);
    }

    showPopover(anchorEl) {
        this.removePopover();

        const wrapper = anchorEl.closest('.js-PC-runnerRow');
        if (!wrapper) {
            return;
        }

        const popover = document.createElement('div');
        popover.className = 'hp-price-button__popover';

        const message = document.createElement('p');
        message.className = 'hp-price-button__popover__message';
        message.textContent = POPOVER_MESSAGE;

        const closeBtn = document.createElement('button');
        closeBtn.className = 'hp-price-button__popover__close';
        closeBtn.setAttribute('type', 'button');
        closeBtn.textContent = '\u00D7';
        closeBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.removePopover();
        });

        popover.appendChild(closeBtn);
        popover.appendChild(message);
        wrapper.appendChild(popover);
        this.popoverEl = popover;

        setTimeout(() => {
            document.addEventListener('click', this.handleOutsideClick, false);
        }, 0);
    }

    handleOutsideClick(event) {
        if (this.popoverEl && !this.popoverEl.contains(event.target)) {
            this.removePopover();
        }
    }

    removePopover() {
        document.removeEventListener('click', this.handleOutsideClick, false);
        if (this.popoverEl) {
            this.popoverEl.remove();
            this.popoverEl = null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/shared/price/BetInterceptor.js